module.exports = __webpack_public_path__ + "img/img4.3b75d1ca.jpg";